<template>
  <div>
    <app-spinner v-if="!is_loaded" />
    <template v-else>
      <app-cells>
        <h1 class="title">Sales manager’s allowance</h1>
        <app-button @click.native="onAllowanceCalculate" size="small" ref="calc">Calculate</app-button>
      </app-cells>
      <v-client-table
        :data="table.items"
        :columns="table.columns"
        :options="table.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader }"
      >
        <template #h__month><div class="table-default__left">Month</div></template>
        <template #h__created><div class="table-default__left">Created</div></template>
        <template #h__updated><div class="table-default__left">Updated</div></template>
        <template #month="{ row }">
          <div class="table-default__left">
            <router-link
              :to=" { name: 'allowance-employee', params: { id: row.id } }"
              class="table-default__link-border"
            >
              {{ dateFormat(row.month) }}
            </router-link>
          </div>
        </template>
        <template #created="{ row }">
          <div class="table-default__left">
            <div v-if="row.created_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.created_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.created_at) }}
            </div>
          </div>
        </template>
        <template #updated="{ row }">
          <div class="table-default__left">
            <div v-if="row.updated_by" class="table-default__controls">
              <div class="table-default__photo">
                <img
                  :src="getUserAvatar(row.updated_by.crop.crop_url)" alt=""
                  v-tooltip="{ content: row.updated_by.full_name, placement: 'top-start', offset: 10 }"
                >
              </div>
              {{ formatDateTime(row.updated_at) }}
            </div>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPagination"
            v-if="pagination.pages > 1"
            v-model="pagination.page"
            :page-count="pagination.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination.count" :count="table.items.length" :page="pagination.page" />
      </app-cells>
    </template>
  </div>
</template>

<script>
import { getEmployeesUTTAllowanceList, postEmployeesUTTAllowance } from '@/http'
import { format, parse, parseISO } from 'date-fns'

export default {
  name: 'AllowanceList',
  data() {
    return {
      is_loaded: false,
      table_preloader: false,
      table: {
        items: [],
        columns: ['month', 'created', 'updated'],
        options: {
          headings: {
            'month': 'Month',
            'created': 'Created',
            'updated': 'Updated',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination: {
        pages: 1,
        page: 1,
        count: 1,
      },
    }
  },
  created() {
    this.fetchItems()
  },
  methods: {
    fetchItems() {
      this.table_preloader = true
      getEmployeesUTTAllowanceList({ page: this.pagination.page, page_size: 20 })
        .then(res => {
          this.table.items = res.data.results
          this.pagination.pages = res.data.pages
          this.pagination.count = res.data.count
          this.is_loaded = true
          this.table_preloader = false
        })
    },
    onAllowanceCalculate() {
      this.$refs.calc.preload = true
      postEmployeesUTTAllowance()
        .finally(() => { this.$refs.calc.preload = false })
        .then(res => { this.$router.push({ name: 'allowance-employee', params: { id: res.data.id } }) })
    },
    onClickPagination(page) {
      this.pagination.page = page
      this.fetchItems()
    },
    dateFormat(date) {
      return format(parse(date, 'yyyy-MM-dd', new Date()), 'MMM yyyy')
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    formatDateTime(date) {
      if (!date) return '-'
      return format(parseISO(date), 'dd MMMM yyyy HH:mm')
    },
  },
}
</script>
